import { AgGridReact } from "@ag-grid-community/react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { ICellRendererParams, IServerSideDatasource } from "ag-grid-community";
import { ServerSideRowModelModule } from "@ag-grid-enterprise/server-side-row-model";

import { ModuleRegistry } from "@ag-grid-community/core";

import { useNavigate } from "react-router-dom";
import { Backdrop, Box, Button, styled } from "@mui/material";
import { Dialog } from "primereact/dialog";
import { useCallback, useEffect, useMemo, useState } from "react";
import axios from "axios";

import * as React from "react";

import SpeedDial, { SpeedDialProps } from "@mui/material/SpeedDial";
import SpeedDialIcon from "@mui/material/SpeedDialIcon";
import SpeedDialAction from "@mui/material/SpeedDialAction";
import FileCopyIcon from "@mui/icons-material/FileCopyOutlined";
import SaveIcon from "@mui/icons-material/Save";
import { GetCompanies } from "../../services/CompanyService";
import { GURL } from "../../services/global";

var enterprise = require("@ag-grid-enterprise/core");
enterprise.LicenseManager.setLicenseKey(
  "DownloadDevTools_COM_NDEwMjM0NTgwMDAwMA==59158b5225400879a12a96634544f5b6"
);
const Companies = () => {
  const [visible, setVisible] = useState(false);
  const [modalNoticeId, setModalNoticeId] = useState("");
  const CellRenderer: React.FC<ICellRendererParams> = ({
    value,
    valueFormatted,
  }) => {
    const cellValue = valueFormatted ? valueFormatted : value;

    useEffect(() => {}, []);
    const buttonClicked = useCallback(() => {
      //alert(`${cellValue} medals won!`);
      setModalNoticeId(value);
      setVisible(true);
    }, []);
    return (
      <span>
        {/* <span>{cellValue}</span>&nbsp; */}
        <Button onClick={buttonClicked}>مشاهده</Button>
      </span>
    );
  };
  const ModalUserCellRenderer: React.FC<ICellRendererParams> = ({
    value,
    valueFormatted,
  }) => {
    //let cellValue = ""; // valueFormatted ? valueFormatted : value;
    const [cellValue, setCellValue] = useState("");

    axios
      .get(
        `${GURL}/Authentication/v1/UserProfile/GetUserProfileById?Id=${value}`
      )
      .then((response) => {
        //00console.log("RER");
        //console.log(response.data.data.firstName);

        setCellValue(
          response.data.data.firstName + " " + response.data.data.lastName
        ); // ;
        console.log(cellValue);

        // Return data to Ag Grid
      })
      .catch((error) => {
        console.error(error);
        // Return error to Ag Grid
      });

    return <span>{cellValue}</span>;
  };
  const ModalActionTypeCellRenderer: React.FC<ICellRendererParams> = ({
    value,
    valueFormatted,
  }) => {
    //let cellValue = ""; // valueFormatted ? valueFormatted : value;

    return <span>{value === 0 ? "تغییر کاربر مسئول" : "ویرایش آگهی"}</span>;
  };

  ModuleRegistry.registerModules([ServerSideRowModelModule]);

  const modalColumns = [
    {
      field: "actionType",
      headerName: "عملیات",
      hide: false,
      sortable: true,
      filter: true,
      cellRenderer: ModalActionTypeCellRenderer,
    },
    {
      field: "actionOwnerUserId",
      headerName: "کاربر مبدا",
      hide: false,
      sortable: true,
      filter: true,
      cellRenderer: ModalUserCellRenderer,
    },
    {
      field: "actionTargetUserId",
      headerName: "کاربر مقصد",
      hide: false,
      sortable: true,
      filter: true,
      cellRenderer: ModalUserCellRenderer,
    },
    {
      field: "oldDescription",
      headerName: "توضیحات قبلی",
      hide: false,
      sortable: true,
      filter: true,
    },
    {
      field: "newDescription",
      headerName: "توضیحات جدید",
      hide: false,
      sortable: true,
      filter: true,
    },
  ];

  const columns = useMemo(
    () => [
      {
        field: "Id",
        hide: true,
        filter: false,
        sortable: false,
      },
      {
        field: "name",
        headerName: "فروشگاه",
        filter: false,
        sortable: false,
      },
      {
        field: "registrationCode",
        headerName: "شماره ثبت",
        filter: false,
        sortable: false,
      },
    ],
    []
  );

  const getData = async () => {
    return await GetCompanies().then((p) => {
      return p.data.data;
    });
  };
  class MyModalServerSideDatasource {
    getRows(params: any) {
      // Make API call to fetch data from server

      getData()
        .then((response) => {
          console.log(response);

          // Return data to Ag Grid
          params.successCallback(response, -1);
        })
        .catch((error) => {
          console.error(error);
          // Return error to Ag Grid
          params.failCallback();
        });
    }
  }

  const navigate = useNavigate();
  const gridOptions = {
    statusBar: {
      statusPanels: [
        {
          statusPanel: "agTotalRowCountComponent",
          align: "left",
          key: "totalRows",
          // Customize the label text
          // The following label text is just an example, you can customize it as needed
          label: "Total Rows: ",
        },
      ],
    },
    onCellDoubleClicked: function (event: any) {
      const { data } = event;
      console.log("Cell double-clicked:", data);
      navigate(`/notice/${data.Id}`);
      // Handle double-click event here
    },
    enableRtl: true,
    defaultColDef: {
      autoHeight: true,
      flex: 1,
    },
    // ... other grid options ...
    localeText: {
      // ... custom translations ...
      notContains: "شامل نشود",
      contains: "شامل شود",
      equals: "برابر باشد با",
      notEqual: "برابر نباشد با",
      startsWith: "شروع شود با",
      endsWith: "پایان یابد با",
      notBlank: "خالی نباشد",
      blank: "خالی باشد",
      loadingOoo: "در حال بارگزاری لطفا منتظر بمانید",
      andCondition: "و",
      orCondition: "یا",
      loadingError: "متاسفانه خطایی در سرور رخ داده است !",
      pageNotFound: "صفحه مورد نظر یافت نشد",
      noRowsToShow: " رکوردی موجود نیست ",
      filterOoo: "فیلتر . . .",
    },
  };

  const MyGrid = useMemo(
    () =>
      React.memo(() => (
        <AgGridReact
          serverSideDatasource={new MyModalServerSideDatasource()}
          rowModelType="serverSide"
          cacheBlockSize={5}
          gridOptions={gridOptions}
          columnDefs={columns}
        ></AgGridReact>
      )),
    [columns]
  );
  return (
    <>
      <div className="mt-2">
        <h6>فروشگاه ها</h6>
      </div>

      <hr />
      <div
        dir="rtl"
        className="mt-2 mb-2  ag-theme-alpine"
        style={{ width: "100%", height: 500 }}
      >
        <MyGrid />
      </div>
    </>
  );
};

export default Companies;
